/**
 * Select/Option変換ユーティリティ
 */

type CodeOption = {
  code: string;
  name: string;
};

type SelectOption = {
  value: string;
  label: string;
};

/**
 * CodeOptionをSelect用のオプション形式に変換
 * 空のコードを持つオプションはフィルタリングする
 *
 * @example
 * toSelectOptions([{ code: '01', name: '一般会計' }])
 * // => [{ value: '01', label: '01:一般会計' }]
 */
export const toSelectOptions = (options: CodeOption[] | null | undefined): SelectOption[] => {
  if (!options) return [];
  return options
    .filter((opt) => opt.code)
    .map((opt) => ({
      value: opt.code,
      label: `${opt.code}:${opt.name}`,
    }));
};
